<template>
    <div class="row col mx-0">
        <div class="alert bg-danger-subtle alert-success col-12 error-preline" role="alert">
            {{ error }}
        </div>
    </div>
</template>

<script>
    'use strict'
    export default {
        name: 'Error',
        props: {
            error: {
                required: true,
                type: [Object, Error]
            }
        },
        created() {
            console.error(this.error)
        }
    }
</script>

<style scoped>
    .error-preline {
        white-space: pre-line;
    }
</style>
